import {
    Directive,
    Input,
    forwardRef,
    OnDestroy,
    OnChanges,
    SimpleChanges
} from '@angular/core'
import {
    NG_VALIDATORS,
    Validator,
    AbstractControl,
    ValidationErrors
} from '@angular/forms'
import { Subscription } from 'rxjs/Subscription'

import { ConfigsBandeirasOperadora } from './configuracao-integracao-bandeira.component'
import { ConfiguracaoIntegracaoBandeiraValidators } from './configuracao-integracao-bandeira.validators'

@Directive({
    selector: '[colConfiguracaoExistente]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ConfiguracaoExistenteDirective,
            multi: true
        }
    ]
})
export class ConfiguracaoExistenteDirective
    implements Validator, OnChanges, OnDestroy {
    @Input() configuracoes: ConfigsBandeirasOperadora[]
    @Input() operadora: AbstractControl
    @Input()
    set colConfiguracaoExistente(value: boolean) {
        this.mustValidate = value
    }

    private mustValidate: boolean
    private operadoraControlSubscription: Subscription

    constructor() {
        this.mustValidate = true
    }

    validate(control: AbstractControl): ValidationErrors {
        if (!this.mustValidate) {
            return null
        }

        if (!this.operadoraControlSubscription) {
            this.subscribeIntoOperadora(control)
        }

        return ConfiguracaoIntegracaoBandeiraValidators.configuracaoExistente(
            this.configuracoes,
            this.operadora
        )(control)
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.operadora && this.operadoraControlSubscription) {
            this.unsubscribeIntoOperadora()
        }
    }

    ngOnDestroy() {
        if (this.operadoraControlSubscription) {
            this.unsubscribeIntoOperadora()
        }
    }

    private subscribeIntoOperadora(control: AbstractControl) {
        this.operadoraControlSubscription = this.operadora.valueChanges.subscribe(
            () => control.updateValueAndValidity()
        )
    }

    private unsubscribeIntoOperadora() {
        this.operadoraControlSubscription.unsubscribe()
        this.operadoraControlSubscription = null
    }
}



// WEBPACK FOOTER //
// ./src/app/configuracao/configuracao-integracao/configuracao-integracao-bandeira/configuracao-existente.directive.ts